module.exports = __webpack_public_path__ + "static/img/logo10.ebb0f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo10.png
// module id = HMYj
// module chunks = 0